<template>
  <el-row class="bg-white">
    <el-card shadow="never" class="w-[538px] m-auto my-4" :body-style="{ display: 'flex' }">
      <ul class="py-0 px-[14px] w-3/5">
        <li class="flex justify-between px-6 pb-2.5 pt-4">
          <div class="license widgets">
            <span class="license-icon mr-2.5"></span>
            <span class="font-bold text-base">Widgets</span>
          </div>
          <input class="outline-hidden border-0 border-b border-jet w-[70px] text-right" type="number" v-model="buyOrderForm.numberOfWidgets">
        </li>
        <li class="flex justify-between px-6 pb-2.5 pt-4">
          <div class="license kiosk">
            <span class="license-icon mr-2.5"></span>
            <span class="font-bold text-base">Kiosk</span>
          </div>
          <input class="outline-hidden border-0 border-b border-jet w-[70px] text-right" type="number" v-model="buyOrderForm.numberOfKiosk">
        </li>
        <li class="flex justify-between px-6 pb-2.5 pt-4">
          <div class="license systems">
            <span class="license-icon mr-2.5"></span>
            <span class="font-bold text-base">Systems</span>
          </div>
          <input class="outline-hidden border-0 border-b border-jet w-[70px] text-right" type="number" v-model="buyOrderForm.numberOfSystem">
        </li>
      </ul>
      <div class="common-form self-end w-2/5 pb-2.5">
        <el-button class="px-[34px] py-2.5 primary" @click="handleSubmitOrder">{{ $t('label.order', 1) }}</el-button>
      </div>
    </el-card>
  </el-row>
</template>

<script src="./order-license-form.js"></script>
